export const CREATE_GRATUITY_RULES_RESIGNATION_LIMITED =
  "CREATE_GRATUITY_RULES_RESIGNATION_LIMITED";
export const FETCH_GRATUITY_RULES_RESIGNATION_LIMITEDS =
  "FETCH_GRATUITY_RULES_RESIGNATION_LIMITEDS";
export const FETCH_GRATUITY_RULES_RESIGNATION_LIMITED =
  "FETCH_GRATUITY_RULES_RESIGNATION_LIMITED";
export const EDIT_GRATUITY_RULES_RESIGNATION_LIMITED =
  "EDIT_GRATUITY_RULES_RESIGNATION_LIMITED";
export const DELETE_GRATUITY_RULES_RESIGNATION_LIMITED =
  "DELETE_GRATUITY_RULES_RESIGNATION_LIMITED";
